module.exports = __webpack_public_path__ + "img/business_grid.c298fd4a.svg";